// ©2024 Austin App House. All rights reserved.
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { toggleSecondModalClose } from '../../storage/actions/modalsActions';

const DeactivateContractorModal = ({ toggleSecondModalClose, modalState }) => {
  const type = modalState?.type || {};
  const contractorName = type.contractorName || 'this contractor';

  const [reason, setReason] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (modalState?.isOpen) {
      setReason('');
      setSubmitting(false);
    }
  }, [modalState?.isOpen]);

  const onClose = () => {
    if (submitting) return;
    toggleSecondModalClose('deactivateContractorModal', true);
  };

  const onCancel = () => {
    if (typeof type.onCancel === 'function') type.onCancel();
    onClose();
  };

  const onSubmit = async () => {
    setSubmitting(true);
    try {
      await type.onConfirm?.({ reason: reason.trim() });
      toggleSecondModalClose('deactivateContractorModal', true);
    } catch (error) {
      setSubmitting(false);
    }
  };

  if (!modalState?.isOpen) return null;

  return (
    <div
      className="modal_block dashboard-modal dashboard-modal--centered modal_import showed"
      role="presentation"
      onClick={onClose}
    >
      <div
        className="modal_container"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal_head">
          <div className="modal_title">Deactivate contractor</div>
          <button type="button" className="close_btn" aria-label="close" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="modal_body">
          <div className="modal_content">
            Please confirm that you want to deactivate
            {' '}
            <strong>{contractorName}</strong>
            {'. '}
            They can still log in and view only completed, approved and paid work orders
            (and export), but will be removed from the client “find contractors” list, will
            no longer receive work-available emails, and cannot have work routed to them.
          </div>

          <div className="field_col">
            <label className="field_name" htmlFor="deactivate-reason">
              Reason (shared with the contractor)
            </label>
            <div className="field_block">
              <textarea
                id="deactivate-reason"
                className="form-control dashboard-input"
                placeholder="Explain why this account is being deactivated (by request, infraction, etc.)"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                maxLength={500}
                rows={5}
              />
            </div>
          </div>
        </div>

        <div className="modal_footer modal_footer--suspend">
          <button
            type="button"
            className="dashboard-btn dashboard-btn--suspend-confirm dashboard-btn--danger-confirm"
            onClick={onSubmit}
            disabled={submitting}
          >
            {submitting ? 'Deactivating…' : 'Deactivate'}
          </button>
          <button
            type="button"
            className="dashboard-btn dashboard-btn--suspend-cancel"
            onClick={onCancel}
            disabled={submitting}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  modalState: state.modalState.deactivateContractorModal,
});

export default connect(mapStateToProps, { toggleSecondModalClose })(DeactivateContractorModal);
